import axios from 'axios';
import { getApiBaseUrl } from './apiConfig';

export const fetchPurchaseRegisterList = async ({ userId }) => {
  const response = await axios.get(`${getApiBaseUrl()}/purchaseregister/getall`, {
    params: { UserId: userId, IsForDropodown: '0' }
  });
  const rows = response?.data?.data;
  return Array.isArray(rows) ? rows : [];
};

export const fetchPurchaseRegisterById = async ({ purchaseRegisterId }) => {
  const response = await axios.get(`${getApiBaseUrl()}/purchaseregister/getbyid`, {
    params: { PurchaseRegisterId: purchaseRegisterId }
  });
  return response?.data?.data ?? { header: null, details: [] };
};

export const savePurchaseRegister = async (payload) => {
  const response = await axios.post(`${getApiBaseUrl()}/purchaseregister/save`, payload);
  return response?.data;
};

export const deletePurchaseRegister = async (payload) => {
  const response = await axios.post(`${getApiBaseUrl()}/purchaseregister/delete`, payload);
  return response?.data;
};
